import { FC, Fragment, useCallback, useContext, useEffect, useState } from "react";
import { useComponentLogger } from "cayo.ui";
import { IWizardCommonProps } from "cayo.ui.wizards";
import { appSignals } from "@cayo/shared/components/App/utils";
import { useUIInteraction } from "@cayo/shared/hooks/useUIInteraction";
import { actionHandlers } from "@cayo/shared/scheme/actions";
import { hasOwnKey } from "@cayo/shared/utils/typeUtils";
import { ProductContext } from "../../contexts/product-context";
import { clientWizardsRenderers } from "../Schemes/renderers/client-wizards.renderers";

type ClientWizardsHolderProps = { onWizardAction: (show: boolean) => void };

export const ClientWizardsHolder: FC<ClientWizardsHolderProps> = ({ onWizardAction }) => {
  const product = useContext(ProductContext);
  const [ClientWizard, setClientWizard] = useState<{
    Comp: FC<IWizardCommonProps>;
    parameters: any;
  }>();
  const [reloadAfterClose, setReloadAfterClose] = useState<boolean>();
  const log = useComponentLogger(ClientWizardsHolder);

  const { alertError } = useUIInteraction();

  //useEffect(() => actionHandlers["show.wizard"]("product-activation,reloadAfterClose"), []);

  useEffect(() => {
    return appSignals.subscribe("showClientWizard", async (prms) => {
      if (!product?.useLegacyLicensing && prms?.schemeId === "ActivationWizard") {
        actionHandlers["show.wizard"]("product-activation,reloadAfterClose");
        return;
      }

      const schemeId = prms?.schemeId;

      if (!hasOwnKey(clientWizardsRenderers, schemeId) || !clientWizardsRenderers[schemeId]) {
        alertError(`${schemeId} not implemented.`);
        return;
      }

      const wizard = clientWizardsRenderers[schemeId];

      // @ts-expect-error TS7053 TODO: Refactor object index types.
      setClientWizard({ Comp: wizard, parameters: prms?.parameters });
      setReloadAfterClose(prms?.reloadAfterClose);

      onWizardAction(true);
    });
  }, [product]);

  const onClose = useCallback(
    (result: boolean) => {
      setClientWizard(undefined);
      setReloadAfterClose(undefined);
      onWizardAction(false);

      if (result && reloadAfterClose) {
        log.debug("reload page");

        window.location.reload();
      }
    },
    [reloadAfterClose]
  );

  if (!ClientWizard) {
    return <Fragment />;
  }

  return <ClientWizard.Comp onClose={onClose} {...ClientWizard.parameters} />;
};
